export default __webpack_public_path__ + "static/media/Clothing supply chain_tablet.dbc187ec.svg";